import { apiFetch, apiUrl, isSuccess } from "./apiClient";

// Resolves exactly these keys against the global list (authored over VAPI —
// precedence is applied server-side) and returns { key: text } for the ones it
// knows (ES-13686). Keys it does not know are absent.
//
// `vapiAvailable: false` means a key missing from the answer may be a VAPI code
// that could not be checked, so the caller must not treat it as a definite miss.
export async function resolveGlobalDisclaimers(keys) {
  const response = await apiFetch(apiUrl("/disclaimers/resolve"), {
    option: "POST",
    body: { keys },
  });

  if (!isSuccess(response)) {
    throw response;
  }

  const data = await response.json();
  return {
    disclaimers: data?.disclaimers ?? {},
    vapiAvailable: data?.vapiAvailable !== false,
  };
}
